// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"334":"app-theme-dark1","522":"app-theme-dark0","554":"app-theme-light1","641":"app-theme-light0"}[chunkId] || chunkId) + "." + {"198":"bc08d063","334":"d8382c81","498":"377eb852","522":"ec130954","554":"185f7310","641":"319b2030","703":"09b158f2"}[chunkId] + ".chunk.js";
};